import React from 'react';
import * as Styled from './styles';
import { sectionsOrganization } from './linksOrganization';

export function Organization() {
  return (
    <Styled.Wrapper>
      <div>
        {sectionsOrganization.map((section) => {
          return (
            <React.Fragment key={section.UUID}>
              <Styled.ContainerColor color={section.color}>
                <section key={section.UUID}>
                  <h1>{section.title}</h1>
                  <Styled.Content>
                    {section.links.map(link => {
                      return (
                        <Styled.ContanierLink key={link.UUID}>
                          <a href={link.href} target="_blank" rel="noreferrer">
                            {link.label}
                          </a>
                        </Styled.ContanierLink>
                      );
                    })}
                  </Styled.Content>
                </section>
              </Styled.ContainerColor>
            </React.Fragment>
          );
        })}
      </div>
    </Styled.Wrapper>
  );
}
